import { Redirect as ReactRouterRedirect, type RedirectProps, useParams } from 'react-router-dom';

import { useCurrentSiteId } from '/module/sites/hooks';

import type { LocationDescriptor, RouteName, RouteParams } from './types';
import { getLocationDescriptorObject } from './util';

export function Redirect(
  props: Omit<RedirectProps, 'to'> & {
    to: LocationDescriptor;
    preserveParams?: boolean;
  },
) {
  const params = useParams<RouteParams>();
  const currentSiteId = useCurrentSiteId();
  let routeObj = props.to;

  if (props.preserveParams) {
    routeObj = typeof props.to === 'object' ? { ...props.to, params } : { pathname: props.to as RouteName, params };
  }

  const to = getLocationDescriptorObject(routeObj, {
    routeParams: {
      siteId: currentSiteId,
    },
  });

  if (to.external && to.pathname) {
    window.location.replace(to.pathname);
    return null;
  }

  return <ReactRouterRedirect {...props} to={to} />;
}
